'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorMessage = undefined;
exports.default = ensureRefIsProvidedByChild;

var _isDOMElement = require('./isDOMElement');

var _isDOMElement2 = _interopRequireDefault(_isDOMElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorMessage = exports.errorMessage = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !(0, _isDOMElement2.default)(children) && !ref) {
    throw new Error(errorMessage);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/react-waypoint/build/ensureRefIsUsedByChild.js
// module id = ./node_modules/react-waypoint/build/ensureRefIsUsedByChild.js
// module chunks = 35783957827783